module.exports = __webpack_public_path__ + "static/img/kjfw_5.4df8690e.png";